import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "../Css/Contact.css";
import email from "../image/New Stud Dash/letter.png";
import call from "../image/New Stud Dash/phone-call.png";
import location from "../image/New Stud Dash/maps-and-flags.png";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import GetStarted from "../component/GetStarted";
import { Input } from "reactstrap";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    category: "",
    city: "",
    message: "",
  });
  const Showerror = (msg) => {
    toast.error(msg, {
      position: "top-right",
      className: "toast-responsive mx-3",
    });
  };
  //custom sucessfully message handle
  const Showsucess = (msg) => {
    toast.success(msg, {
      position: "top-right",
      className: "toast-responsive mx-3",
    });
  };
  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/contact`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      Showsucess(response?.data?.message);
      setFormData({
        name: "",
        email: "",
        phone: "",
        category: "",
        city: "",
        message: "",
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        Showerror(error.response.data.error);
      } else {
        Showerror("Something went wrong! Please try again.");   
      }
    }
  };
  return (
    <>
      <Container fluid style={{ background: '#1E2538' }} className="hero_all overflow-hidden">
        <Row className="justify-content-center">
          <Col xl="12">
            <div class="header_banner align-self-center  text-center pt-0">
              <br />
              <div className="main_part positions-relative">
                <div className="fs-3  head_text text-white">Contact Us</div>
                <h1 class="fw-bold h1_title"> Get In Touch With Us</h1>
              </div>
              <br />
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="pt-5 pb-4 contact_us">
        <Row className="pt-4 justify-content-center">
          <Col md="6" xs="12" lg={4} className="mb-sm-5 mb-4  d-flex justify-content-center">
            <div className="d-flex col-12  align-items-center">
              <div className="Icon_Box d-flex align-items-center justify-content-center">
                <img src={call} alt="phone-call" height={25} />
              </div>
              <div className="ms-4">
                <h5 className="SubTitle_Box">Call to ask any question</h5>
                <div className=""><Link className="pointer SubTitle_Box_1" to={"tel:+91-8238235437"}>+91 82382 35437</Link></div>
              </div>
            </div>
          </Col>
          <Col md="6" xs="12" lg={4} className="mb-sm-5 mb-4  d-flex justify-content-center">
            <div className="d-flex col-12  align-items-center">
              <div className="Icon_Box d-flex align-items-center justify-content-center">
                <img src={email} alt="email" height={25} />
              </div>
              <div className="ms-4">
                <h5 className="SubTitle_Box">Email us</h5>
                  <Link to="mailto:info@careersahi.com" className="text-decoration-none pointer SubTitle_Box_1">
                    info@careersahi.com
                  </Link>
              </div>
            </div>
          </Col>
          <Col md="6" xs="12" lg={4} className="mb-sm-5 mb-4 d-flex justify-content-center">
            <div className="d-flex col-12">
              <div className="Icon_Box d-flex align-items-center justify-content-center">
                <img src={location} alt="location" height={25} />
              </div>
              <div className="ms-4">
                <h5 className="SubTitle_Box">Visit our office</h5>
                <div className="SubTitle_Box_1">Surat, Gujarat</div>
              </div>
            </div>
          </Col>
        </Row>
        <section className="pt-4">
          <Row className="justify-content-center">
            <Col lg={7} className="d-flex justify-content-center">
              <Form onSubmit={handleSubmit} className="col-11">
                <h4 style={{ color: '#1E2538' }} className="Get_Touch text-center">
                  Get in Touch With Our Career Experts!
                </h4>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  name="name"
                  value={formData.name}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                  className="input my-2"
                />
                <Row>
                  <Col lg={6}>
                    <Form.Control
                      type="email"
                      placeholder="Email"
                      autoComplete="off"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="input my-2"
                    />
                  </Col>
                  <Col lg={6}>
                    <Form.Control
                      type="tel"
                      autoComplete="off"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Phone"
                      className="input my-2"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Form.Select
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      required
                      className="input my-2"
                    >
                      <option value="" disabled selected>
                        -Select-
                      </option>
                      <option value="Student (8-10 Std)">
                        Student (8-10 Std)
                      </option>
                      <option value="Student (11-12 Std)">
                        Student (11-12 Std)
                      </option>
                      <option value="Student (UG)">Student (UG)</option>
                      <option value="Student (PG)">Student (PG)</option>
                      <option value="Parent (8-10 Std)">Parent (8-10 Std)</option>
                      <option value="Parent (11-12 Std)">
                        Parent (11-12 Std)
                      </option>
                      <option value="Parent (UG)">Parent (UG)</option>
                      <option value="Parent (PG)">Parent (PG)</option>
                      <option value="Working Professional (1-10 yrs exp)">
                        Working Professional (1-10 yrs exp)
                      </option>
                      <option value="Senior Working Professional (10+ yrs exp)">
                        Senior Working Professional (10+ yrs exp)
                      </option>
                      <option value="Executive with Career Break">
                        Executive with Career Break
                      </option>
                      <option value="Principal/Teacher">Principal/Teacher</option>
                      <option value="Others">Others</option>
                    </Form.Select>
                  </Col>
                  <Col lg={6}>
                    <Form.Control
                      type="text"
                      placeholder="City"
                      name="city"
                      autoComplete="off"
                      value={formData.city}
                      onChange={handleChange}
                      className="input my-2"
                    />
                  </Col>
                </Row>
                <Input
                  type="textarea"
                  placeholder="Anything We Need To Know? (Optional)"
                  className="mt-2 input mb-3"
                  name="message"
                  autoComplete="off"
                  value={formData.message}
                  onChange={handleChange}
                />
                <div className="text-center">
                  <Button type="submit" className="submit_btn text-white border-0 custome_button px-5 py-2">
                    Submit
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </section>
      </Container>
      {/* contact */}
      <GetStarted/>
    </>
  );
};

export default Contact;
